/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgWarning40(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={40}
      height={40}
      fill='none'
      viewBox='0 0 40 40'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M17.577 10.52a.75.75 0 01.75-.75h3.346a.75.75 0 01.75.75v10.595a.75.75 0 01-.039.237l-.557 1.673a.75.75 0 01-.712.513h-2.23a.75.75 0 01-.712-.513l-.557-1.673a.75.75 0 01-.039-.237V10.521zm1.5.75v9.724l.348 1.044h1.15l.348-1.044V11.27h-1.846zM20 25.384a2.423 2.423 0 100 4.845 2.423 2.423 0 000-4.845zm-.923 2.422a.923.923 0 111.846 0 .923.923 0 01-1.846 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M19.47 1.792a.75.75 0 011.06 0L38.208 19.47a.75.75 0 010 1.06L20.53 38.208a.75.75 0 01-1.06 0L1.792 20.53a.75.75 0 010-1.06L19.47 1.792zM20 3.383L3.383 20 20 36.617 36.617 20 20 3.383z'
      />
    </svg>
  );
}

export default SvgWarning40;
